import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';

//Material-UI
import makeStyles from '@material-ui/core/styles/makeStyles';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';

//Iconos
//DS
import { hooks, SelectPlus, PasswordDs, FmBase } from 'lib.front';
import { validacion } from 'lib.common';

import { esquemaCampos, esquemaValidacion, esquemaQuery } from './esquemas';


//Estilos del componente
const useStyles = makeStyles(theme => ({
   container: {
      display: 'flex',
      flexWrap: 'wrap'
   },
   textField: {
      width: '100%'
   },
   textFieldUsuario: {
      width: '96%'
   },
   textFieldPass: {
      width: '93%'
   },
   margin: {
      marginTop: theme.spacing(1),
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1)
   },
   marginClave: {
      marginLeft: theme.spacing(1)
   },
   selectPlus: {
      marginTop: theme.spacing(0),
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: '100%'
   },
   controlMargin: {
      margin: theme.spacing(1)
   },
   formlabel: {
      textAlign: 'left',
      margin: theme.spacing(1)
   },
   left: {
      alignItems: 'start'
   }
}));
// componentes auxiliares
const entidadTipoDoc = 'clientesTipoDoc';
const camposTipoDoc = ['codigo', 'descripcion'];
//Componente principal
function Cliente({ open, handleCloseModal, usuario }) {
   //Inicializar Estilos del componente
   const classes = useStyles();
   esquemaCampos.codigo.valor = usuario.codigo;
   //Obtenemos estados de informacion y objetos para su manejo y validacion
   const {
      campos, existeError: existeErrorInput, handleOnChange, validacionManual, setCampo
   } = hooks.useValidacion(esquemaCampos, esquemaValidacion);

   //Estados de control del formulario
   const [disabled, setDisabled] = useState(false);

   //Estados para representar los datos
   const [esJuridico, setesJuridico] = useState(false);
   /*
    Efectos
    */
   useEffect(() => {
      let data = campos.nroDoc.valor;
      if (validacion.esRucValido(data) === true && data.substr(0, 2) === '20')
         setesJuridico(true);
      else
         setesJuridico(false);
   }, [campos.nroDoc.valor]);

   /*
    Funciones para manejar el cambio en los estados de datos, modificar o aumentar funciones de ser necesario
    */
   /*
    Funciones a sobreescribir para personalizar el modulo
    */
   //const inicializarFormulario = () => {
   //    inicializar();
   //};
   //
   async function generarParametros() {
      const params = {
         codigo: campos.codigo.valor,
         tipoDoc: campos.tipoDoc.valor ? campos.tipoDoc.valor.value : null,
         nroDoc: campos.nroDoc.valor,
         nombre: campos.nombre.valor,
         apPaterno: campos.apPaterno.valor,
         apMaterno: campos.apMaterno.valor,
         razonSocial: campos.razonSocial.valor,
         usuario: campos.usuario.valor,
         email: campos.email.valor,
         telefono: campos.telefono.valor,
         contacto: campos.contacto.valor,
         observacion: campos.observacion.valor,
         activo: 1
      };
      if (campos.pass.valor !== '') {
         params.pass = campos.pass.valor;
      }

      return params;
   }
   //
   const asignarValoresEstados = async (data) => {
      //setCampo('tipoDoc', { value: data.tipoDoc, label: data.tipoDoc  })
      setCampo('tipoDoc', {
         value: data.tipoDoc.codigo,
         label: data.tipoDoc.descripcion
      });
      setCampo('nroDoc', data.nroDoc || '');
      setCampo('nombre', data.nombre || '');
      setCampo('apPaterno', data.apPaterno || '');
      setCampo('apMaterno', data.apMaterno || '');
      setCampo('razonSocial', data.razonSocial || '');
      setCampo('usuario', data.usuario);
      //setCampo('pass', data.pass);
      //setCampo('pass2', data.pass);
      setCampo('email', data.email || '');
      setCampo('telefono', data.telefono || '');
      setCampo('contacto', data.contacto || '');
      setCampo('observacion', data.observacion || '');
      //setCampo('activo', data.activo);
   };

   //Variables locales
   //const [valor, setValor] = useState(null);
   //const onChangeTipodoc = (selectedOption) => {
   //    campos.tipoDoc.valor = selectedOption.value;
   //    setValor(selectedOption);
   //}
   //const onBlurNrodoc = event => {
   //    let dato = event.target.value;
   //};
   //function asignarUsuario() {
   //    if (esNuloGen(campos.usuario.valor)) return campos.codigo.valor;
   //    else return campos.usuario.valor;
   //}
   //Componentes auxiliares
   const clave = () => {
      return (
         <TextField
            label="Código"
            name="codigo"
            value={campos.codigo.valor}
            onChange={handleOnChange}
            error={campos.codigo.error !== ''}
            helperText={campos.codigo.error}
            disabled={true}
            className={clsx(classes.marginClave)}
            margin="dense"
            variant="outlined"
            required
            autoFocus
            InputProps={{
               readOnly: true
            }} />
      );
   };

   return (
      <Container maxWidth="md">
         <FmBase
            titulo="Perfil"
            entidad="cliente"
            //inicializar={inicializarFormulario}
            campos={esquemaQuery}
            generarParametros={generarParametros}
            asignarValoresEstados={asignarValoresEstados}
            existeErrorInput={existeErrorInput}
            clave={clave}
            open={open}
            handleCloseModal={handleCloseModal}
            cancelarNoVisible
            eliminarNoVisible
            llamarRecuperar
         >
            <Grid
               container
               spacing={2}
               direction="row"
               justify="flex-start"
               alignItems="flex-start"
            >
               <Divider light />
               <Grid item xs={4}>
                  <div className={classes.selectPlus}>
                     <SelectPlus
                        name="tipoDoc"
                        label="Tipo Doc."
                        //data={tipoDoc} -- el caso de una data json
                        entidad={entidadTipoDoc}
                        campos={camposTipoDoc}
                        value={campos.tipoDoc.valor}
                        onChange={elegido => {
                           validacionManual('tipoDoc', elegido);
                        }}
                        genId={registro => {
                           return registro.codigo;
                        }}
                        genLabel={registro => {
                           return registro.descripcion;
                        }}
                        error={campos.tipoDoc.error !== ''}
                        helperText={campos.tipoDoc.error}
                        disabled={true}
                        variant="outlined"
                        margin="dense"
                        excesoElementos
                        InputProps={{
                           readOnly: true
                        }} />
                  </div>
               </Grid>
               <Grid item xs={5}>
                  <TextField
                     name="nroDoc"
                     label="Nro. Doc."
                     value={campos.nroDoc.valor}
                     onChange={handleOnChange}
                     //onBlur={onBlurNrodoc}
                     error={campos.nroDoc.error !== ''}
                     helperText={campos.nroDoc.error}
                     disabled={true}
                     className={clsx(classes.margin, classes.textField)}
                     margin="dense"
                     variant="outlined"
                     required
                     InputProps={{
                        readOnly: true
                     }} />
               </Grid>
               <Divider light />
               {esJuridico === !true && (
                  <Grid item xs={4}>
                     <TextField
                        name="nombre"
                        label="Nombres"
                        value={campos.nombre.valor}
                        onChange={handleOnChange}
                        error={campos.nombre.error !== ''}
                        helperText={campos.nombre.error}
                        disabled={true}
                        className={clsx(classes.margin, classes.textField)}
                        margin="dense"
                        variant="outlined"
                        InputProps={{
                           readOnly: true
                        }} />
                  </Grid>
               )}
               {esJuridico === !true && (
                  <Grid item xs={4}>
                     <TextField
                        name="apPaterno"
                        label="Ap. Paterno"
                        value={campos.apPaterno.valor}
                        onChange={handleOnChange}
                        error={campos.apPaterno.error !== ''}
                        helperText={campos.apPaterno.error}
                        disabled={true}
                        className={clsx(classes.margin, classes.textField)}
                        margin="dense"
                        variant="outlined"
                        InputProps={{
                           readOnly: true
                        }} />
                  </Grid>
               )}
               {esJuridico === !true && (
                  <Grid item xs={4}>
                     <TextField
                        name="apMaterno"
                        label="Ap. Materno"
                        value={campos.apMaterno.valor}
                        onChange={handleOnChange}
                        error={campos.apMaterno.error !== ''}
                        helperText={campos.apMaterno.error}
                        disabled={true}
                        className={clsx(classes.margin, classes.textField)}
                        margin="dense"
                        variant="outlined"
                        InputProps={{
                           readOnly: true
                        }} />
                  </Grid>
               )}
               <Divider light />
               {esJuridico === true && (
                  <Grid item xs={12}>
                     <TextField
                        name="razonSocial"
                        label="Razón Social"
                        value={campos.razonSocial.valor}
                        onChange={handleOnChange}
                        error={campos.razonSocial.error !== ''}
                        helperText={campos.razonSocial.error}
                        disabled={true}
                        className={clsx(classes.margin, classes.textField)}
                        margin="dense"
                        variant="outlined"
                        InputProps={{
                           readOnly: true
                        }} />
                  </Grid>
               )}
               <Divider light />
               <Grid item xs={6}>
                  <Paper elevation={6} square>
                     <TextField
                        name="usuario"
                        label="Usuario"
                        value={campos.usuario.valor} //campos.usuario.valor}
                        onChange={handleOnChange}
                        error={campos.usuario.error !== ''}
                        helperText={campos.usuario.error}
                        disabled={true}
                        className={clsx(classes.margin, classes.textFieldUsuario)}
                        margin="dense"
                        variant="outlined"
                        required
                        InputProps={{
                           readOnly: true
                        }} />
                  </Paper>
               </Grid>
               <Grid item xs={3}>
                  <Paper elevation={6} square>
                     <PasswordDs
                        name="pass"
                        label="Clave"
                        value={campos.pass.valor}
                        onChange={handleOnChange}
                        error={campos.pass.error !== ''}
                        helperText={campos.pass.error}
                        className={clsx(classes.margin, classes.textFielPass)}
                        margin="dense"
                        variant="outlined"
                        toggle
                        required
                        InputProps={{
                           readOnly: false
                        }} />
                  </Paper>
               </Grid>
               <Grid item xs={3}>
                  <Paper elevation={6} square>
                     <PasswordDs
                        name="pass2"
                        label="Repetir Clave"
                        value={campos.pass2.valor}
                        onChange={handleOnChange}
                        error={campos.pass2.error !== ''}
                        helperText={campos.pass2.error}
                        className={clsx(classes.margin, classes.textFieldPass)}
                        margin="dense"
                        variant="outlined"
                        toggle
                        InputProps={{
                           readOnly: false
                        }} />
                  </Paper>
               </Grid>
               <Divider light />
               <Grid item xs={6}>
                  <TextField
                     name="email"
                     label="Email"
                     value={campos.email.valor}
                     onChange={handleOnChange}
                     error={campos.email.error !== ''}
                     helperText={campos.email.error}
                     className={clsx(classes.margin, classes.textField)}
                     margin="dense"
                     variant="outlined" />
               </Grid>
               <Grid item xs={6}>
                  <TextField
                     name="telefono"
                     label="Teléfono"
                     value={campos.telefono.valor}
                     onChange={handleOnChange}
                     error={campos.telefono.error !== ''}
                     helperText={campos.telefono.error}
                     className={clsx(classes.margin, classes.textField)}
                     margin="dense"
                     variant="outlined" />
               </Grid>
               <Divider light />
               <Grid item xs={12}>
                  <TextField
                     name="contacto"
                     label="Persona Contacto"
                     value={campos.contacto.valor}
                     onChange={handleOnChange}
                     error={campos.contacto.error !== ''}
                     helperText={campos.contacto.error}
                     className={clsx(classes.margin, classes.textField)}
                     margin="dense"
                     variant="outlined" />
               </Grid>
               <Divider light />
               <Grid item xs={12}>
                  <TextField
                     name="observacion"
                     label="Observación"
                     value={campos.observacion.valor}
                     onChange={handleOnChange}
                     error={campos.observacion.error !== ''}
                     helperText={campos.observacion.error}
                     className={clsx(classes.margin, classes.textField)}
                     margin="dense"
                     variant="outlined" />
               </Grid>
            </Grid>
         </FmBase>
      </Container>
   );
}

function mapStateToProps(state) {
   return {
      usuario: state.auth.usuario
   };
}

function mapDispatchToProps(dispatch) {
   return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(Cliente);